/* tslint:disable */
/* eslint-disable */
//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.13.2.0 (NJsonSchema v10.5.2.0 (Newtonsoft.Json v11.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming

import axios, { AxiosError, AxiosInstance, AxiosRequestConfig, AxiosResponse, CancelToken } from 'axios';

export class Client {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {
        this.instance = instance ? instance : axios.create();
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * Get countries autocomplete (Auth)
     * @param planttype 0 = AUTOMATION_PLANT
    
    1 = ENTRANCE_PLANT
     * @return List of countries
     */
    countriesAutocomplete(planttype: PlantType , cancelToken?: CancelToken | undefined): Promise<Country[]> {
        let url_ = this.baseUrl + "/countries-autocomplete/{planttype}";
        if (planttype === undefined || planttype === null)
            throw new Error("The parameter 'planttype' must be defined.");
        url_ = url_.replace("{planttype}", encodeURIComponent("" + planttype));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCountriesAutocomplete(_response);
        });
    }

    protected processCountriesAutocomplete(response: AxiosResponse): Promise<Country[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Country.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("Generic error", status, _responseText, _headers);
        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);
        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Country[]>(<any>null);
    }

    /**
     * Get default rooms list with default values (Auth)
     * @return List of default rooms with values
     */
    defaultRoomsList(  cancelToken?: CancelToken | undefined): Promise<DefaultRoomDTO[]> {
        let url_ = this.baseUrl + "/default-rooms-list";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDefaultRoomsList(_response);
        });
    }

    protected processDefaultRoomsList(response: AxiosResponse): Promise<DefaultRoomDTO[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DefaultRoomDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("Generic error", status, _responseText, _headers);
        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);
        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DefaultRoomDTO[]>(<any>null);
    }

    /**
     * Get default settings for DeksTool client
     * @return A JSON object containing the defaults for the desktool client
     */
    defaultSettings(  cancelToken?: CancelToken | undefined): Promise<DeskToolClientSettingsDTO> {
        let url_ = this.baseUrl + "/desktool-client/default-settings";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDefaultSettings(_response);
        });
    }

    protected processDefaultSettings(response: AxiosResponse): Promise<DeskToolClientSettingsDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DeskToolClientSettingsDTO.fromJS(resultData200);
            return result200;
        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("Generic error", status, _responseText, _headers);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DeskToolClientSettingsDTO>(<any>null);
    }

    /**
     * Returns a flat list of all the entities of the given type across all the plant.
    Use 0 as plantdesktopid when id is not available (Auth)
     * @param plantdesktopid PlantId
     * @param etype PlantEntityType
    
    0 = ROOM
    
    1 = SCENE
    
    2 = GROUP
    
    3 = ROOM_OBJECT
    
    4 = PLANT
     * @return Plant Entities Flattened List
     */
    flattenedEntities(plantdesktopid: number, etype: PlantEntityType , cancelToken?: CancelToken | undefined): Promise<PlantFlatEntityDTO[]> {
        let url_ = this.baseUrl + "/plant/{plantdesktopid}/flattened-entities/{etype}";
        if (plantdesktopid === undefined || plantdesktopid === null)
            throw new Error("The parameter 'plantdesktopid' must be defined.");
        url_ = url_.replace("{plantdesktopid}", encodeURIComponent("" + plantdesktopid));
        if (etype === undefined || etype === null)
            throw new Error("The parameter 'etype' must be defined.");
        url_ = url_.replace("{etype}", encodeURIComponent("" + etype));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processFlattenedEntities(_response);
        });
    }

    protected processFlattenedEntities(response: AxiosResponse): Promise<PlantFlatEntityDTO[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PlantFlatEntityDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);
        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);
        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("Plant doesn\'t exist or not owned", status, _responseText, _headers);
        } else if (status === 412) {
            const _responseText = response.data;
            return throwException("Eliot parse exception", status, _responseText, _headers);
        } else if (status === 503) {
            const _responseText = response.data;
            return throwException("Eliot API not working", status, _responseText, _headers);
        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("A generic error occurred", status, _responseText, _headers);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PlantFlatEntityDTO[]>(<any>null);
    }
}

export class Country implements ICountry {
    code?: string | undefined;
    name?: string | undefined;
    timeZoneId?: string | undefined;
    extendedName?: string | undefined;

    constructor(data?: ICountry) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["code"];
            this.name = _data["name"];
            this.timeZoneId = _data["timeZoneId"];
            this.extendedName = _data["extendedName"];
        }
    }

    static fromJS(data: any): Country {
        data = typeof data === 'object' ? data : {};
        let result = new Country();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["name"] = this.name;
        data["timeZoneId"] = this.timeZoneId;
        data["extendedName"] = this.extendedName;
        return data; 
    }
}

export interface ICountry {
    code?: string | undefined;
    name?: string | undefined;
    timeZoneId?: string | undefined;
    extendedName?: string | undefined;
}

export class DefaultRoomDTO implements IDefaultRoomDTO {
    type?: RoomType;
    count?: number;
    icon?: string | undefined;
    label?: string | undefined;

    constructor(data?: IDefaultRoomDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.type = _data["type"];
            this.count = _data["count"];
            this.icon = _data["icon"];
            this.label = _data["label"];
        }
    }

    static fromJS(data: any): DefaultRoomDTO {
        data = typeof data === 'object' ? data : {};
        let result = new DefaultRoomDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        data["count"] = this.count;
        data["icon"] = this.icon;
        data["label"] = this.label;
        return data; 
    }
}

export interface IDefaultRoomDTO {
    type?: RoomType;
    count?: number;
    icon?: string | undefined;
    label?: string | undefined;
}

export class DeskToolClientSettingsDTO implements IDeskToolClientSettingsDTO {
    uiSettings?: any | undefined;
    plantRefreshInterval?: number;
    azureAdb2CClientId?: string | undefined;
    azureAdb2CAuthority?: string | undefined;
    azureAdb2CKnownAuthority?: string | undefined;
    azureAdb2CFullAccessScope?: string | undefined;
    instrumentationKey?: string | undefined;
    profileUrl?: string | undefined;
    entrancePlantEnabled?: boolean;

    constructor(data?: IDeskToolClientSettingsDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.uiSettings = _data["uiSettings"];
            this.plantRefreshInterval = _data["plantRefreshInterval"];
            this.azureAdb2CClientId = _data["azureAdb2CClientId"];
            this.azureAdb2CAuthority = _data["azureAdb2CAuthority"];
            this.azureAdb2CKnownAuthority = _data["azureAdb2CKnownAuthority"];
            this.azureAdb2CFullAccessScope = _data["azureAdb2CFullAccessScope"];
            this.instrumentationKey = _data["instrumentationKey"];
            this.profileUrl = _data["profileUrl"];
            this.entrancePlantEnabled = _data["entrancePlantEnabled"];
        }
    }

    static fromJS(data: any): DeskToolClientSettingsDTO {
        data = typeof data === 'object' ? data : {};
        let result = new DeskToolClientSettingsDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["uiSettings"] = this.uiSettings;
        data["plantRefreshInterval"] = this.plantRefreshInterval;
        data["azureAdb2CClientId"] = this.azureAdb2CClientId;
        data["azureAdb2CAuthority"] = this.azureAdb2CAuthority;
        data["azureAdb2CKnownAuthority"] = this.azureAdb2CKnownAuthority;
        data["azureAdb2CFullAccessScope"] = this.azureAdb2CFullAccessScope;
        data["instrumentationKey"] = this.instrumentationKey;
        data["profileUrl"] = this.profileUrl;
        data["entrancePlantEnabled"] = this.entrancePlantEnabled;
        return data; 
    }
}

export interface IDeskToolClientSettingsDTO {
    uiSettings?: any | undefined;
    plantRefreshInterval?: number;
    azureAdb2CClientId?: string | undefined;
    azureAdb2CAuthority?: string | undefined;
    azureAdb2CKnownAuthority?: string | undefined;
    azureAdb2CFullAccessScope?: string | undefined;
    instrumentationKey?: string | undefined;
    profileUrl?: string | undefined;
    entrancePlantEnabled?: boolean;
}

/** 0 = ROOM 1 = SCENE 2 = GROUP 3 = ROOM_OBJECT 4 = PLANT */
export enum PlantEntityType {
    ROOM = 0,
    SCENE = 1,
    GROUP = 2,
    ROOM_OBJECT = 3,
    PLANT = 4,
}

export class PlantFlatEntityDTO implements IPlantFlatEntityDTO {
    id?: string | undefined;
    roomType?: RoomType;
    objectType?: RoomObjectType;
    currentName?: string | undefined;
    plantEntityType?: PlantEntityType;

    constructor(data?: IPlantFlatEntityDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.roomType = _data["roomType"];
            this.objectType = _data["objectType"];
            this.currentName = _data["currentName"];
            this.plantEntityType = _data["plantEntityType"];
        }
    }

    static fromJS(data: any): PlantFlatEntityDTO {
        data = typeof data === 'object' ? data : {};
        let result = new PlantFlatEntityDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["roomType"] = this.roomType;
        data["objectType"] = this.objectType;
        data["currentName"] = this.currentName;
        data["plantEntityType"] = this.plantEntityType;
        return data; 
    }
}

export interface IPlantFlatEntityDTO {
    id?: string | undefined;
    roomType?: RoomType;
    objectType?: RoomObjectType;
    currentName?: string | undefined;
    plantEntityType?: PlantEntityType;
}

/** 0 = AUTOMATION_PLANT 1 = ENTRANCE_PLANT */
export enum PlantType {
    AUTOMATION_PLANT = 0,
    ENTRANCE_PLANT = 1,
}

/** 0 = Light 1 = Shutter 2 = Socket 3 = Lock 4 = Thermostat 5 = Fancoil 6 = TowelWarmer 7 = WirelessCommand 8 = Blind 9 = Player 10 = Xmeter 11 = Alarm 12 = ColoredLight 13 = ScheduledScenarioPlus 14 = None 15 = Contact 16 = AlarmSensor 17 = Thermostat99zones 18 = DimmerDmx 19 = DimmerDali 20 = Actuactor 21 = CentralLoadControl 22 = ActuactorLoadControl 23 = VdeLock 24 = StaircaseLight 25 = FloorCall 26 = Unknown */
export enum RoomObjectType {
    Light = 0,
    Shutter = 1,
    Socket = 2,
    Lock = 3,
    Thermostat = 4,
    Fancoil = 5,
    TowelWarmer = 6,
    WirelessCommand = 7,
    Blind = 8,
    Player = 9,
    Xmeter = 10,
    Alarm = 11,
    ColoredLight = 12,
    ScheduledScenarioPlus = 13,
    None = 14,
    Contact = 15,
    AlarmSensor = 16,
    Thermostat99zones = 17,
    DimmerDmx = 18,
    DimmerDali = 19,
    Actuactor = 20,
    CentralLoadControl = 21,
    ActuactorLoadControl = 22,
    VdeLock = 23,
    StaircaseLight = 24,
    FloorCall = 25,
    Unknown = 26,
}

/** 0 = Livingroom 1 = Bathroom 2 = Kitchen 3 = Bedroom 4 = Dining_room 5 = Toilets 6 = Lobby 7 = Corridor 8 = Garage 9 = Outdoor 10 = Home_office 11 = Stairs 12 = Electrical_cabinet 13 = Custom 14 = Unknown */
export enum RoomType {
    Livingroom = 0,
    Bathroom = 1,
    Kitchen = 2,
    Bedroom = 3,
    Dining_room = 4,
    Toilets = 5,
    Lobby = 6,
    Corridor = 7,
    Garage = 8,
    Outdoor = 9,
    Home_office = 10,
    Stairs = 11,
    Electrical_cabinet = 12,
    Custom = 13,
    Unknown = 14,
}

export class ApiException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new ApiException(message, status, response, headers, null);
}

function isAxiosError(obj: any | undefined): obj is AxiosError {
    return obj && obj.isAxiosError === true;
}